import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/** Redirect legacy /coach/my-trainings/:sport/:assessmentType URLs to the unified performance flow. */
const CoachMyTrainingsLegacyRedirect: React.FC = () => {
  const { sport, assessmentType } = useParams<{ sport: string; assessmentType: string }>();
  const safeSport = sport || 'Badminton';
  const safeAssessment = assessmentType || 'skill-assessment-beginner-self';
  return (
    <Navigate
      to={`/coach/performance/${encodeURIComponent(safeSport)}/${encodeURIComponent(safeAssessment)}`}
      replace
    />
  );
};

export default CoachMyTrainingsLegacyRedirect;
